import React from "react";

const Button = (props) => {
  return (
    <>
      <button
        className={
          props.btnclasses === undefined ? "btn" : "btn " + props.btnclasses
        }
        onClick={props.onClick !== undefined ? props.onClick : null}
      >
        {props.btnText}
      </button>
    </>
  );
};

export default Button;
